interface InsightItemProps {
  label: string;
  value: string | null;
}

export const InsightItem = ({ label, value }: InsightItemProps) => (
  <p>
    <span className="font-bold">{label}: </span>
    {value ?? '-'}
  </p>
);
